import { useMemo } from 'react'
import { CircularProgress } from '@material-ui/core'
import { displayReadableTime } from '../../services/displayReadableTime'
import { makeStyles } from '@material-ui/core/styles'
import MyTable from '../MyTable/MyTable'
import PropTypes from 'prop-types'

const styles = makeStyles((theme) => ({
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
  tableUnset: {
    whiteSpace: 'unset',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
}))

const AuditDetailsItem = (props) => {
  const classes = styles(props)
  const {
    blossomIDFromParent,
    timezoneDataFromParent,
    auditDataFromParent,
    fetchingState,
    pageSizeFromParent,
    pageFromParent,
    callbackFromParentPage,
    callbackFromParentAuditData,
    callbackFromParentPageSize,
  } = props

  var tempData = []

  const columns = useMemo(
    () => [
      {
        Header: 'Audit Details',
        columns: [
          {
            Header: 'Time Modified',
            accessor: 'timestamp',
            maxWidth: 175,
            minWidth: 175,
            width: 175,
            disableResizing: true,
            disableSortBy: true,
          },
          {
            Header: 'Modified by',
            accessor: 'requested_by_id',
            maxWidth: 125,
            width: 125,
            minWidth: 125,
            disableResizing: true,
            disableSortBy: true,
          },
          {
            Header: 'Action Taken',
            accessor: 'action',
            maxWidth: 175,
            width: 175,
            minWidth: 175,
            disableResizing: true,
            disableSortBy: true,
          },
          {
            Header: 'Previous Value',
            accessor: 'previous_state',
            disableSortBy: true,
            Cell: (row) => (
              <div className={classes.tableUnset}>{row.value}</div>
            ),
          },
          {
            Header: 'Requested Value',
            accessor: 'requested_state',
            disableSortBy: true,
            Cell: (row) => (
              <div className={classes.tableUnset}>{row.value}</div>
            ),
          },
        ],
      },
    ],
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )

  const scrubData = (jsonList) => {
    // take slice to skip over first row that has total rows no longer needed
    if (jsonList == null) {
      jsonList = []
    }
    var newData1 = jsonList.map((el) => {
      if (el.timestamp !== 'None') {
        return Object.assign({}, el, {
          timestamp: displayReadableTime(el.timestamp, timezoneDataFromParent),
        })
      }
      return el
    })
    return newData1
  }

  // pass only array data
  if (auditDataFromParent !== null) {
    tempData = scrubData(auditDataFromParent['audit_data'])
  }

  if (fetchingState) {
    return (
      <div className={classes.centerDiv}>
        <CircularProgress className={classes.spinner} thickness={7} />
        <h3>loading...</h3>
      </div>
    )
  } else {
    return (
      <>
        <MyTable
          columns={columns}
          data={tempData}
          manualPagination={true}
          defaultPageSize={pageSizeFromParent}
          defaultPageIndex={pageFromParent}
          maxPageCount={Math.ceil(
            auditDataFromParent['total_entries_available'] / pageSizeFromParent,
          )}
          onPageChange={(pageIndex) => {
            callbackFromParentPage(pageIndex)
            callbackFromParentAuditData(
              blossomIDFromParent,
              pageIndex,
              pageSizeFromParent,
            )
          }}
          onPageSizeChange={(pageSize, pageIndex) => {
            callbackFromParentPage(pageIndex)
            callbackFromParentPageSize(pageSize)
            callbackFromParentAuditData(
              blossomIDFromParent,
              pageIndex,
              pageSize,
            )
          }}
          disableSort={true}
        />
      </>
    )
  }
}

export default AuditDetailsItem

AuditDetailsItem.propTypes = {
  blossomIDFromParent: PropTypes.string.isRequired,
  timezoneDataFromParent: PropTypes.string.isRequired,
  auditDataFromParent: PropTypes.shape({
    total_entries_available: PropTypes.number,
    audit_data: PropTypes.arrayOf(
      PropTypes.shape({
        timestamp: PropTypes.string,
        requested_by_id: PropTypes.string,
        action: PropTypes.string,
        previous_state: PropTypes.string,
        requested_state: PropTypes.string,
      }),
    ),
  }),
  fetchingState: PropTypes.bool,
  pageSizeFromParent: PropTypes.number.isRequired,
  pageFromParent: PropTypes.number.isRequired,
  callbackFromParentPage: PropTypes.func.isRequired,
  callbackFromParentAuditData: PropTypes.func.isRequired,
  callbackFromParentPageSize: PropTypes.func.isRequired,
}
